module.exports = __webpack_public_path__ + "static/ART_Logo-usage_correct2-f7300f009213ddbebf73e07f0fd41164.svg";